import React, { useState } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { changePassword } from '../../../redux/modules/auth'
import { reduxForm } from 'redux-form'
import FormTextField from '../../../components/FormTextField'
import { required, passwordStrength, passwordMatch } from '../../../utilties/validators'
import Button from '@material-ui/core/Button'
import { useTheme, withStyles } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import * as cookies from '../../../utilties/cookies'
import FormPassword from '../../../components/FormPassword'

const styles = {
  input: {
    color: 'white',
    fontSize: '1.7rem'
  },

}

const useStyles = makeStyles((theme) => ({
  gridStyle: {
    padding: '4rem',
    [theme.breakpoints.down('sm')]: {
      padding: '3rem 2rem',
    }
  },
  formStyle: {
    width: 'calc(300px + 4rem)',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(300px + 4rem)',
      width: '100%',
    }
  },
  inputLabel: {
    fontSize: '1.7rem'
  }
}))


const requiredValidator = required
const passwordStrengthValidator = passwordStrength
const passwordMatchValidator = passwordMatch('newPassword')

const ChangePassword = ({ intl, handleSubmit, submitRequest }) => {
  const [patient] = useState(cookies.get('user'))

  const classes = useStyles()
  const theme = useTheme();

  const onSubmitForm = values => {
    submitRequest(patient.email, values.existingPassword, values.newPassword)
  }

  return (
    <form data-testid="form-change-password" onSubmit={handleSubmit(onSubmitForm)} className={classes.formStyle}>
      <div>
        <Grid container direction="column" className={classes.gridStyle}>
          <Grid item style={{ paddingBottom: '20px', textAlign: 'center', textTransform: 'uppercase' }}>
            <Typography
              variant="h3"
              data-testid="change-password-title">{intl.formatMessage({ id: 'app.changePassword.title' })}</Typography>
          </Grid>

          <Grid item >
            <FormPassword
              data-testid="change-password-existing-password"
              label={intl.formatMessage({ id: 'app.changePassword.existingPasswordLabel' })}
              fullWidth variant="filled"
              name="existingPassword"
              inputLabelProps
              inputProps={{ className: classes.input }}
              validators={[requiredValidator]}
            />
          </Grid>
          <Grid item>
            <Typography variant="caption">
              {intl.formatMessage({ id: 'app.passwordRequirements' })}
            </Typography>
          </Grid>
          <Grid item>
            <FormPassword
              data-testid="change-password-new-password"
              label={intl.formatMessage({ id: 'app.changePassword.newPasswordLabel' })}
              fullWidth variant="filled"
              name="newPassword"
              inputLabelProps={{ className: classes.input }}
              inputProps={{ className: classes.input }}
              validators={[requiredValidator, passwordStrengthValidator]}
            />
          </Grid>
          <Grid item >
            <FormPassword
              data-testid="change-password-confirm-password"
              label={intl.formatMessage({ id: 'app.confirmPassword.confirmPasswordLabel' })}
              fullWidth variant="filled"
              name="confirmPassword"
              inputLabelProps={{ className: classes.input }}
              inputProps={{ className: classes.input }}
              validators={[requiredValidator, passwordMatchValidator]}
            />
          </Grid>

          <Grid item style={{ textAlign: 'center'}}>
            <Button
              data-testid="change-password-button-submit"
              variant='contained'
              color='primary'
              type="submit">
              {intl.formatMessage({ id: 'app.changePassword.buttonLabel' })}
            </Button>
          </Grid>
        </Grid>
      </div>
    </form>
  )
}

const mapStateToProps = (state, ownProps) => ({
  // email: emailSelector(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  submitRequest: (email, oldPassword, newPassword) => dispatch(changePassword(email, oldPassword, newPassword)),
})

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
  reduxForm({ form: 'changePassword' }),
  withStyles(styles)
)

export default enhance(ChangePassword)
